import { render, staticRenderFns } from "./PreviewForm.vue?vue&type=template&id=35e68f97&scoped=true&"
import script from "./PreviewForm.vue?vue&type=script&lang=js&"
export * from "./PreviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e68f97",
  null
  
)

export default component.exports